import _extends from '@babel/runtime/helpers/extends';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import * as React from 'react';
import { mergeRefs } from '@react-aria/utils';
import { InternalSelectionListItem } from './components/SelectionListItem/components/InternalSelectionListItem/InternalSelectionListItem.js';
import { SelectionListLabel } from './components/SelectionListLabel/SelectionListLabel.js';
import { InternalSelectionListSection } from './components/SelectionListSection/components/InternalSelectionListSection.js';
import { SelectionListBoxContext } from './context/SelectionListBoxContext.js';
import { useVirtualizedSelectionListBox } from './hooks/useVirtualizedSelectionListBox.js';

// Virtualized version of the SelectionListBox component based on @tanstack/react-virtual library
var VirtualizedSelectionListBox = /*#__PURE__*/React.memo(/*#__PURE__*/React.forwardRef(function (props, ref) {
  var selectionMode = props.selectionMode,
    label = props.label;
  var _useVirtualizedSelect = useVirtualizedSelectionListBox(props),
    state = _useVirtualizedSelect.state,
    listBoxProps = _useVirtualizedSelect.listBoxProps,
    containerProps = _useVirtualizedSelect.containerProps,
    listBoxRef = _useVirtualizedSelect.listBoxRef,
    labelProps = _useVirtualizedSelect.labelProps,
    virtualizedProps = _useVirtualizedSelect.virtualizedProps;
  var _ref = virtualizedProps || {},
    parentRef = _ref.parentRef,
    virtualizer = _ref.virtualizer;
  var renderListItem = React.useCallback(function (item) {
    var index = item.index;
    var listItems = _toConsumableArray(state.collection);
    var listItem = listItems[index];
    if (!listItem) {
      return null;
    }
    var itemVirtualizedProps = {
      size: item.size,
      start: item.start
    };
    return listItem.type === 'section' ? /*#__PURE__*/React.createElement(InternalSelectionListSection, {
      key: listItem.key,
      section: listItem,
      state: state,
      virtualizedProps: itemVirtualizedProps
    }) : /*#__PURE__*/React.createElement(InternalSelectionListItem, {
      key: listItem.key,
      item: listItem,
      state: state,
      virtualizedProps: itemVirtualizedProps
    });
  }, [state]);
  var labelElement = React.useMemo(function () {
    return label && /*#__PURE__*/React.createElement(SelectionListLabel, {
      label: label,
      labelProps: labelProps
    });
  }, [label, labelProps]);
  if (!virtualizer) {
    return null;
  }
  var virtualItems = virtualizer.getVirtualItems();
  return /*#__PURE__*/React.createElement(SelectionListBoxContext.Provider, {
    value: {
      selectionMode: selectionMode,
      isVirtualized: true
    }
  }, labelElement, /*#__PURE__*/React.createElement("div", _extends({
    ref: parentRef
  }, containerProps), /*#__PURE__*/React.createElement("ul", _extends({}, listBoxProps, {
    ref: mergeRefs(ref, listBoxRef)
  }), virtualItems.map(renderListItem))));
}));

export { VirtualizedSelectionListBox };
//# sourceMappingURL=VirtualizedSelectionListBox.js.map
